import StepOne from "@/components/dashboard/withdrawMoney/StepOne";

export default function WithdrawMoneyStepOne() {
  return <StepOne />;
}
